import { faVial } from "@fortawesome/pro-regular-svg-icons";
import React from "react";

import { FlowVersion } from "src/api/flowTypes";
import { Pill } from "src/base-components/Pill";
import { UpdatedByInfo } from "src/flowContainer/versionEditedInfo/utils";
import { useRelativeTime } from "src/hooks/useRelativeTime";
import { useSimulationRun } from "src/simulations/useSimulationRun";

type Props = { flowVersion: FlowVersion; flowId: string; simulationId: string };

export const LastSimulatedInfo: React.FC<Props> = ({
  flowVersion,
  flowId,
  simulationId,
}) => {
  const { data: simulationRun } = useSimulationRun(
    flowId,
    flowVersion.id,
    simulationId,
  );

  const timeFromNow = useRelativeTime(simulationRun?.created_at);

  const trigger = simulationRun?.trigger;
  const updatedBy =
    trigger?.type === "manual" ? trigger.triggered_by : undefined;

  return (
    <Pill dataLoc="last-simulated-info" variant="indigo-light">
      <Pill.Icon icon={faVial} />
      <Pill.Text fontType="text">
        Simulated {timeFromNow} <UpdatedByInfo updatedBy={updatedBy} />
      </Pill.Text>
    </Pill>
  );
};
